import map from 'lodash/map';
import Player from '@vimeo/player';
import SmoothScroll from 'smooth-scroll';
import trim from 'lodash/trim';

/* global document, Drupal, jQuery */
(($) => {
  Drupal.behaviors.certsTheme = {
    attach: () => {
      $(document).ready(() => {
        $('body').once('certs-theme-features').each(() => {
          // if (document.querySelector('.paragraph--type-metrics')) {
          //   [...document.querySelectorAll('.paragraph--type-metrics')].forEach((metrics) => {
          //     console.log({ metrics });
          //   });
          // }

          // Bootstrap dropdowns in exposed filters
          const persistDropdown = () => {
            $('.views-exposed-form .dropdown-menu').on('click touch', (evt) => {
              evt.stopPropagation();
            });
            $('.views-exposed-form .dropdown-menu [type="checkbox"]').on('change', (evt) => {
              evt.stopPropagation();
            });
            $('.views-exposed-form .dropdown-menu [type="submit"]').on('click touch', (evt) => {
              evt.preventDefault();
              $(evt.target).closest('form').find('.form actions .form-submit').first().click();
            })
          };
          persistDropdown();
          $(window).ajaxComplete(persistDropdown);

          // Active filters
          const updateFilters = () => {
            const view = document.querySelector('.view-job-board');
            if (view) {
              const filters = view.querySelector('.view-filters');
              const active = view.querySelector('.views-active-filters');
              const submit = view.querySelector('.form-actions [type="submit"]');
              const footer = view.querySelector('.view-footer');
              active.innerHTML = '';
              if (filters) {
                // Add each of the checkbox filters to the active filters container
                map(filters.querySelectorAll('[type="checkbox"]:checked'), (checkbox) => {
                  const label = filters.querySelector(`label[for="${checkbox.id}"]`);
                  const textLabel = trim(label.innerText);
                  const button = document.createElement('button');
                  button.innerHTML = textLabel + "<span class='sr-only'>, cancel this selection</span> ";
                  button.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    label.click();
                    submit.click();
                  });
                  active.appendChild(button);
                });
                // Add the keyword search value, if any
                const keyword = filters.querySelector('.form-item-keyword [type="text"]');
                if (keyword && keyword.value) {
                  const button = document.createElement('button');
                  button.innerHTML = `keyword: "${keyword.value}"`;
                  button.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    keyword.value = '';
                    submit.click();
                  });
                  active.appendChild(button);
                }
              }
            }
          };
          updateFilters();
          $(window).ajaxComplete(updateFilters);

          // Ensure links inside of image grid items don't open the video modal.
          const imageGridLinks = document.querySelectorAll('.paragraph--type-image-grid-item .field--name-field-link a');
          if (imageGridLinks) {
            [...imageGridLinks].forEach((link) => {
              $(link).on('click touch', (evt) => {
                evt.stopPropagation();
              })
            });
          }

          //tools and guides print button
          $('.print-btn').click(function() {
            $('.panel-collapse').css("display", "block");
            window.print();
            return false;
          });

          // view-tabs
          const embeds = document.querySelectorAll('[data-deferred-embed]');
          if (embeds) {
            map(embeds, (embed) => {
              if ($(embed).closest('.view-tabs').length === 0) {
                const uuid = embed.getAttribute('data-deferred-embed');
                /* global drupalSettings */
                const html = JSON.parse(drupalSettings.deferredEmbed[uuid]);
                /* eslint-disable no-param-reassign */
                if (!embed.innerHTML) embed.innerHTML = html;
              }
            });
          }

          // Anchor links smooth scrolling to position.
          if (document.querySelector('.view-anchor-links')) {
            $('.view-anchor-links a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function (event) {
              // On-page links
              if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
              ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  $('html, body').animate({
                    scrollTop: target.offset().top - 50
                  }, 1000, function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                      return false;
                    } else {
                      $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                      $target.focus(); // Set focus again
                    };
                  });
                  // Add the hash to the URL when done scrolling (default click behavior)
                  window.history.pushState(null, null, this.hash);
                }
              }
            });
          }

          // Duplicate tab navigation for mobile
          $('.paragraph--type-tabs').each((index, tabs) => {
            $('.nav-tabs', $(tabs)).each((idx, nav) => {
              const items = nav.querySelectorAll('li');
              if (items && items.length > 2) {
                $(nav).addClass('hidden-mobile');
                const links = nav.querySelectorAll('a');
                const clonedLinks = map(links, link => link.cloneNode(true));
                const $tabContainer = $(`
                  <div class="mobile-tab-dropdown">
                    <button>
                      IN THIS SECTION
                    </button>
                    <div class="mobile-tab-links"></div>
                  </div>
                `);
                $tabContainer.find('.mobile-tab-links').prepend(clonedLinks);
                $tabContainer.find('button').on('click touch', (evt) => {
                  const $button = $(evt.currentTarget);
                  $button.next('div').toggleClass('is-expanded');
                  $button.toggleClass('is-expanded');
                });
                $(tabs).prepend($tabContainer);
              } else {
                $(nav).addClass('show-mobile');
              }
            });
          });

          $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            const id = e.target.getAttribute('href');
            if (document.querySelector(id)) {
              const newEmbeds = document.querySelector(id).querySelectorAll('[data-deferred-embed]');
              if (newEmbeds) {
                map(newEmbeds, (embed) => {
                  const uuid = embed.getAttribute('data-deferred-embed');
                  /* global drupalSettings */
                  const html = JSON.parse(drupalSettings.deferredEmbed[uuid]);
                  /* eslint-disable no-param-reassign */
                  if (!embed.innerHTML) embed.innerHTML = html;
                });
              }
            }
            const scroll = new SmoothScroll(false);
            let scrollTarget = e.target;
            if (document.querySelector('.mobile-tab-dropdown') &&
                document.querySelector('.mobile-tab-dropdown').offsetHeight) {
              scrollTarget = document.querySelector('.mobile-tab-dropdown');
            }
            const rect = scrollTarget.getBoundingClientRect();
            if (rect.top < 0) {
              scroll.animateScroll(scrollTarget, false, {
                offset: () => {
                  let offset = 0;
                  if (document.querySelector('.mm-page') &&
                      document.querySelector('.mm-page').style['padding-top']) {
                    offset = parseInt(document.querySelector('.mm-page').style['padding-top'], 10);
                  }
                  return offset;
                },
                updateURL: false,
              });
            }
          });

          // Move modals so the overlay works
          $('.modal').each((index, element) => {
            $(element).appendTo('body');
          });

          // Stop dropdown from closing on story filters
          $('.block-views-exposed-filter-blockstories-stories .form-type-checkbox').on('click touch', (evt) => {
            evt.stopPropagation();
          });

          // Don't trigger overlay when clicking staff email on teaser
          $('.node--type-staff.node--view-mode-teaser .field--name-field-email-address a').on('click touch', (evt) => {
            evt.stopPropagation();
          });

          // Track tab position in the hash
          /* global window, history, location */
          if (window.location.hash) {
            const hashVal = window.location.hash.replace('#', '');
            const $activeTab = $(`a[data-toggle="tab"][data-slug="${hashVal}"]`);
            $activeTab.tab('show');
            $(`.mobile-tab-links [data-slug="${hashVal}"]`).addClass('is-active');
          } else {
            $('.mobile-tab-links a:first-of-type').addClass('is-active');
          }
          $('.paragraph--type-tab, .paragraph--type-tabs').addClass('is-loaded');
          $('a[data-toggle="tab"]').on('shown.bs.tab', (evt) => {
            const slug = $(evt.target).data('slug');
            $('.mobile-tab-links a').removeClass('is-active');
            $(`.mobile-tab-links [data-slug="${slug}"]`).addClass('is-active');
            $('.mobile-tab-dropdown .is-expanded').removeClass('is-expanded');
            const hashVal = window.location.hash.replace('#', '');
            if (slug !== hashVal) {
              /* eslint-disable no-restricted-globals */
              if (history.pushState) {
                history.pushState(null, null, `#${slug}`);
              } else {
                location.hash = `#${slug}`;
              }
            }
          });
          $(window).on('popstate', () => {
            const hashVal = window.location.hash.replace('#', '');
            const displayedTab = document.querySelector('.active > a[data-toggle="tab"]');
            if (displayedTab) {
              const slug = $(displayedTab).data('slug');
              if (slug !== hashVal) {
                if (hashVal) {
                  const $activeTab = $(`a[data-toggle="tab"][data-slug="${hashVal}"]`);
                  $activeTab.tab('show');
                } else {
                  const firstTab = document.querySelector('a[data-toggle="tab"]');
                  $(firstTab).click();
                }
              }
            }
          });

          // Menu hovers
          const menuItems = document.querySelectorAll('.navbar-nav .dropdown.expanded');
          map(menuItems, (menuItem) => {
            /* global hoverintent */
            /* eslint-disable func-names */
            hoverintent(
              menuItem,
              function () {
                const $menu = $(this);
                const $submenu = $menu.find('.sub-menu');
                $submenu.removeClass('slideInDown').addClass('slideInDown');
                $menu.addClass('open').addClass('is-hovered');
              },
              function () {
                const $menu = $(this);
                const $submenu = $menu.find('.sub-menu');
                $submenu.removeClass('slideInDown').addClass('slideOutUp');
                $menu.removeClass('is-hovered');
                setTimeout(() => {
                  $menu.removeClass('open');
                  $submenu.addClass('slideInDown').removeClass('slideOutUp');
                }, 400);
              },
            );
          });

          // Stories
          const updateClearStoryFilters = (target) => {
            target && $('#stories-by-topic').dropdown('toggle');
            const $form = target ? $(target).closest('form') : $('#views-exposed-form-stories-stories');

            if ($form && document.querySelector('.clear-story-filters')) {
              if ($form.find('.form-checkbox:checked').length) {
                document.querySelector('.clear-story-filters').style.opacity = 1;
                document.querySelector('.clear-story-filters').style['pointer-events'] = 'all';
              } else {
                document.querySelector('.clear-story-filters').style.opacity = 0;
                document.querySelector('.clear-story-filters').style['pointer-events'] = 'none';
              }
            }
          };

          updateClearStoryFilters();

          $('#views-exposed-form-stories-stories .form-submit').on('click touch', (evt) => {
            updateClearStoryFilters(evt.target);
          });

          // Video start/stop
          $('.paragraph--type-video-slide[data-toggle="modal"], .paragraph--type-image-grid-item[data-toggle="modal"]').on('click', (evt) => {
            // Vimeo videos
            const target = $(evt.currentTarget).data('target');
            const $modal = $(target);
            const iframe = $('.video-embed-field-provider-vimeo iframe', $modal);
            if (iframe.length > 0) {
              const player = new Player(iframe);
              player.play();
            }
            // Youtube videos
            const youtubeIframe = $('.video-embed-field-provider-youtube iframe', $modal);
            if (youtubeIframe.length > 0) {
              youtubeIframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
          });

          // When a bootstrap modal is closed, stop vimeo videos
          $(document).on('hide.bs.modal', (evt) => {
            const iframe = $('.video-embed-field-provider-vimeo iframe', $(evt.target));
            if (iframe.length > 0) {
              const player = new Player(iframe);
              player.pause();
            }
            // Youtube videos
            const youtubeIframe = $('.video-embed-field-provider-youtube iframe', $(evt.target));
            if (youtubeIframe.length > 0) {
              youtubeIframe[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            }
          });

          // Add a close button to mmenu
          $('.mm-navbar').each((index, navbar) => {
            const $closeButton = $('<button class="mm-close-mm">Close</button>');
            $closeButton.on('click touch', () => {
              document.querySelector('#off-canvas').mmApi.close();
            });
            if (!$(navbar).find('.mm-close-mm').length) {
              $(navbar).append($closeButton);
            }
          });

          // Search block toggle
          $('#block-searchform').each((index, searchBlock) => {
            $('h2', $(searchBlock)).click(() => {
              $('form', $(searchBlock)).slideToggle('fast');
              $('#block-searchform input#edit-keys').focus();
            });
          });

          const searchForm = document.getElementById('search-block-form');
          if (searchForm) {
            const cloneForm = searchForm.cloneNode(true);
            cloneForm.removeAttribute('id');
            $('#off-canvas .mm-listview').after($(cloneForm));
          }

          $(".view-slideshow").each(function() {
            var slideshow = $(this);
            if ($(".carousel-inner .item", this).length < 2) {
              slideshow.find(".left").hide();
              slideshow.find(".right").hide();
            }
          });
        });
      });
    },
  };
})(jQuery);
